import avatar0 from '../images/Midaslogo.jpeg';
import avatar1 from '../images/idyll_logo.jpg';
import avatar2 from '../images/pepcoding_logo.jpg';
import avatar3 from '../images/ncomputing_logo.png';
import avatar4 from '../images/shree_balaiji_logo_circle.png';
import avatar5 from '../images/avatars/5.webp';
import avatar6 from '../images/avatars/6.webp';

const images = {
	avatar0,
	avatar1,
	avatar2,
	avatar3,
	avatar4,
	avatar5,
	avatar6,
};

export default images;
